import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Card, Btn, Input } from "@/components/erp/ui";
import { MediaInput } from "@/components/erp/prod/ProdInputs";
import { Sparkles } from "lucide-react";

const err = (e) => toast.error(e?.response?.data?.detail || "Gagal");
const ph = (xs) => xs.map((x) => (typeof x === "string" ? x : x.path || x.url)).filter(Boolean);

const Pick = ({ machines, onStart }) => {
  const [sel, setSel] = useState([]);
  const tog = (id) => setSel(sel.includes(id) ? sel.filter((x) => x !== id) : sel.length < 3 ? [...sel, id] : sel);
  return (
    <div>
      <p className="text-[11px] text-slate-500 mb-2">Pilih 1–3 mesin sekali jalan, lalu Mulai. Waktu dihitung sampai Selesai dan dibagi rata per mesin.</p>
      <div className="flex flex-wrap gap-1.5 mb-2">{machines.filter((m) => !["BREAKDOWN", "OFFLINE"].includes(m.status)).map((m) => <button key={m.id} type="button" data-testid={`lite-pick-${m.id}`} onClick={() => tog(m.id)} className={`text-xs px-2.5 py-1 rounded-full border ${sel.includes(m.id) ? "bg-teal-600 text-white border-teal-600" : "border-slate-300 bg-white"}`}>{m.name}{m.last_lite ? "" : " · belum pernah"}</button>)}</div>
      <Btn data-testid="lite-start" disabled={!sel.length} onClick={() => onStart(sel)}>Mulai lite maintenance ({sel.length})</Btn>
    </div>
  );
};

const Run = ({ s, lite, reload }) => {
  const [res, setRes] = useState({}); const [note, setNote] = useState(""); const [photos, setPhotos] = useState([]);
  const set = (mid, key, ok) => setRes({ ...res, [mid]: { ...(res[mid] || {}), [key]: ok } });
  const finish = async () => {
    const results = Object.fromEntries(s.machine_ids.map((mid) => [mid, lite.map((p) => ({ key: p.key, ok: res[mid]?.[p.key] })).filter((p) => p.ok !== undefined)]));
    try { const { data } = await api.post("/lite-maint/finish", { results, note, photos: ph(photos) }); toast.success(`Lite maintenance selesai · ${data.minutes} mnt`); reload(); } catch (e) { err(e); }
  };
  return (
    <div className="space-y-2">
      <div className="text-xs text-teal-700 font-semibold" data-testid="lite-running">Berjalan sejak {new Date(s.start).toLocaleTimeString("id-ID")} · {s.machines.join(", ")}</div>
      {s.machine_ids.map((mid, i) => (
        <div key={mid} className="rounded-lg border border-slate-200 p-2" data-testid={`lite-machine-${mid}`}><b className="text-xs">{s.machines[i]}</b>
          {lite.map((p) => <div key={p.key} className="flex items-center gap-2 text-xs py-0.5"><span className="flex-1">{p.label}</span>
            {[[true, "OK"], [false, "Masalah"]].map(([v, l]) => <button key={l} type="button" data-testid={`lite-${mid}-${p.key}-${v ? "ok" : "bad"}`} onClick={() => set(mid, p.key, v)} className={`px-2 py-0.5 rounded-full border ${res[mid]?.[p.key] === v ? (v ? "bg-emerald-600 text-white border-emerald-600" : "bg-rose-600 text-white border-rose-600") : "border-slate-300"}`}>{l}</button>)}</div>)}
        </div>))}
      <Input data-testid="lite-note" placeholder="Catatan (opsional)" value={note} onChange={(e) => setNote(e.target.value)} />
      <MediaInput value={photos} onChange={setPhotos} max={4} testid="lite-photo" label="Foto bukti *" />
      <Btn data-testid="lite-finish" onClick={finish}>Selesai</Btn>
    </div>
  );
};

// Lite maintenance mingguan (operator/teknisi): 1 user bisa 1–3 mesin sekali jalan
export const LiteMaint = ({ machines = [], onChanged }) => {
  const [d, setD] = useState(null);
  const load = () => api.get("/lite-maint/me").then(({ data }) => setD(data)).catch(() => setD(null));
  useEffect(() => { load(); }, []);
  const reload = () => { load(); onChanged && onChanged(); };
  const start = async (ids) => { try { await api.post("/lite-maint/start", { machine_ids: ids }); toast.success("Lite maintenance dimulai"); reload(); } catch (e) { err(e); } };
  if (!d) return null;
  return (
    <Card className="p-4 mb-4" data-testid="lite-maint">
      <h3 className="font-semibold text-sm mb-1 flex items-center gap-1.5"><Sparkles className="w-4 h-4 text-teal-600" />Lite maintenance mingguan</h3>
      <p className="text-[11px] text-slate-500 mb-2">{d.lite.map((p) => p.label).join(" · ")}</p>
      {d.session ? <Run s={d.session} lite={d.lite} reload={reload} /> : <Pick machines={machines} onStart={start} />}
    </Card>
  );
};
